import dayjs from 'dayjs';

import { utcDTStr2UTC } from 'utils/dateTime';
import { prizeRedeemDateLimitTypes } from 'config/promoPrizeTypes';
import getPrizeRedeemWithinEndUtc, {
    getPrizeRedeemWithinMonthEndUtc
} from 'client/utils/getPrizeRedeemWithinEndUtc';

export function getPrizeRedeemExpiredInfo({
    redeemTimeType,
    redeemStartDate,
    redeemEndDate,
    redeemWithinDays,
    redeemWithinDateTime,
    redeemWithinMonthsLastDay,
    winnerCreatedAt
}) {
    // 時間區間
    if (redeemTimeType === prizeRedeemDateLimitTypes.RANGE && redeemStartDate && redeemEndDate) {
        const startDateUtc = utcDTStr2UTC(redeemStartDate);
        const endDateUtc = utcDTStr2UTC(redeemEndDate);
        const hasStart = dayjs().isAfter(dayjs(startDateUtc));
        const hasExpired = dayjs().isAfter(dayjs(endDateUtc));
        return { startDateUtc, endDateUtc, hasExpired, hasStart, hasSetRedeemDateLimit: true };
    }

    // 配獎後 N 天內
    if (redeemTimeType === prizeRedeemDateLimitTypes.WITHIN && redeemWithinDays !== undefined) {
        const startDateUtc = utcDTStr2UTC(winnerCreatedAt);
        const endDateUtc = getPrizeRedeemWithinEndUtc(winnerCreatedAt, redeemWithinDays);
        const hasStart = dayjs().isAfter(dayjs(startDateUtc));
        const hasExpired = dayjs().isAfter(dayjs(endDateUtc));
        return { startDateUtc, endDateUtc, hasExpired, hasStart, hasSetRedeemDateLimit: true };
    }

    // 固定到期日
    if (redeemTimeType === prizeRedeemDateLimitTypes.FIXED_EXPIRATION && redeemWithinDateTime) {
        const startDateUtc = utcDTStr2UTC(winnerCreatedAt);
        const endDateUtc = utcDTStr2UTC(redeemWithinDateTime);
        const hasStart = dayjs().isAfter(dayjs(startDateUtc));
        const hasExpired = dayjs().isAfter(dayjs(endDateUtc));
        return { startDateUtc, endDateUtc, hasExpired, hasStart, hasSetRedeemDateLimit: true };
    }

    // 配獎後 N 月後月底
    if (
        redeemTimeType === prizeRedeemDateLimitTypes.WITHIN_MONTH_LAST_DAY &&
        redeemWithinMonthsLastDay
    ) {
        const startDateUtc = utcDTStr2UTC(winnerCreatedAt);
        const endDateUtc = getPrizeRedeemWithinMonthEndUtc(
            winnerCreatedAt,
            redeemWithinMonthsLastDay
        );
        const hasStart = dayjs().isAfter(dayjs(startDateUtc));
        const hasExpired = dayjs().isAfter(dayjs(endDateUtc));
        return { startDateUtc, endDateUtc, hasExpired, hasStart, hasSetRedeemDateLimit: true };
    }

    return { hasStart: true, hasExpired: false, hasSetRedeemDateLimit: false };
}

export const prizeStatusLabels = {
    REDEEMED: 'REDEEMED',
    HAS_NOT_FILL_FORM: 'HAS_NOT_FILL_FORM',
    EXPIRED: 'EXPIRED'
};
